export default "__VITE_ASSET__5FNid9xX__"